var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntroToFigmaResources(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7051_33237)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#882E46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 -33C18.1666 -15.5 16.4999 24.5 32.4999 44.5C52.4999 69.5 156 59.5 184.5 87.5C213 115.5 209.5 142 206.5 173.5C203.5 205 158 227 121.5 215.5C85 204 32.4999 228.5 32.4999 284.5",
    stroke: "#E1B7C2",
    strokeWidth: 8,
    strokeDasharray: "15 15"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 54.5,
    r: 23.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7852 64H56.0312V52.9375C56.0312 51.6172 56.0625 50.5703 56.125 49.7969C55.9453 49.9844 55.7227 50.1914 55.457 50.418C55.1992 50.6445 54.3242 51.3633 52.832 52.5742L51.4492 50.8281L56.4883 46.8672H58.7852V64Z",
    fill: "#9C0E33"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.5,
    cy: 208.5,
    r: 23.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.312 218H173.699V215.914L178.117 211.473C179.422 210.137 180.285 209.191 180.707 208.637C181.137 208.074 181.449 207.547 181.645 207.055C181.84 206.562 181.938 206.035 181.938 205.473C181.938 204.699 181.703 204.09 181.234 203.645C180.773 203.199 180.133 202.977 179.312 202.977C178.656 202.977 178.02 203.098 177.402 203.34C176.793 203.582 176.086 204.02 175.281 204.652L173.793 202.836C174.746 202.031 175.672 201.461 176.57 201.125C177.469 200.789 178.426 200.621 179.441 200.621C181.035 200.621 182.312 201.039 183.273 201.875C184.234 202.703 184.715 203.82 184.715 205.227C184.715 206 184.574 206.734 184.293 207.43C184.02 208.125 183.594 208.844 183.016 209.586C182.445 210.32 181.492 211.316 180.156 212.574L177.18 215.457V215.574H185.312V218Z",
    fill: "#9C0E33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 99,
    width: 129,
    height: 22,
    rx: 8,
    fill: "#6C1C29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: -13,
    width: 129,
    height: 22,
    rx: 8,
    fill: "#6C1C29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 247,
    width: 129,
    height: 22,
    rx: 8,
    fill: "#6C1C29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 129,
    width: 129,
    height: 22,
    rx: 8,
    fill: "#6C1C29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 159,
    width: 67,
    height: 22,
    rx: 8,
    fill: "#6C1C29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 17,
    width: 95,
    height: 22,
    rx: 8,
    fill: "#6C1C29"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7051_33237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroToFigmaResources);
export default __webpack_public_path__ + "static/media/intro-to-figma-resources.cdf836babf44c0256fbaa1e77f1fd5ab.svg";
export { ForwardRef as ReactComponent };